import React, { Component } from 'react';
import { Row, Input } from "antd";
import Table1 from "./5-1-1";
import Table2 from "./5-1-2";
import Table3 from "./5-1-3";
import Table4 from "./5-1-4";
import Table5 from "./5-1-5";

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            update5_1: false,
            update5_1_3: false
        }
    }

    onChange = (name, value) => {
        this.setState({ [name]: value });
    }

    render() {
        return (
            <div>
                <Row style={{ margin: "24px 0 24px 24px", fontSize: 22, color: "#333" }}>
                    5.1 F&B Revenue Analysis By Outlets 餐饮收入分析-按餐厅
                </Row>
                <Table1 {...this.props} onChange={this.onChange} />
                <Table2 {...this.props} onChange={this.onChange} update={this.state.update5_1} />
                <Table3 {...this.props} onChange={this.onChange} update={this.state.update5_1} />
                <Table4 {...this.props} onChange={this.onChange} update={this.state.update5_1_3} />
                <Table5 {...this.props} />
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-1/index.js